export const getApiMessage = (x) => {
    if (!x) return "";
    if (typeof x === "string") return x;
    const cand =
        x.error?.message ||
        x.error ||
        x.data?.message ||
        x.response?.data?.message ||
        x.message ||
        x.statusText;
    return typeof cand === "string" ? cand : "";
};
